module.exports = __webpack_public_path__ + "img/background-panel-hello-max.a87978eb.svg";